
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {getOneproductsdb } from '../../api/productsdb.api'
import {customsizesperproduct_68e5866ca5fe5912e60022b3 } from '../../api/productsizesdb.api'

import './productinfo.scss';






const Pproductinfo = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyendpoint_68e5829ea5fe5912e6002105, setLoftyEndpoint_68e5829ea5fe5912e6002105] = useState({});
		const [loftyres_68e5866ca5fe5912e60022b3_component_ivdhx7, setloftyres_68e5866ca5fe5912e60022b3_component_ivdhx7] = useState([]);

	const [loftyfilter_68e5829ea5fe5912e6002105__id_iwyddl_ivdhx7, set_loftyfilter_68e5829ea5fe5912e6002105__id_iwyddl_ivdhx7] = useState();

useEffect(() => {
		const loftyHandleData = async () => {
			const loftyres_68e5829ea5fe5912e6002105 = await getOneproductsdb({ _id: match.params._id, token: loftytoken || 'asdsa' });
			setLoftyEndpoint_68e5829ea5fe5912e6002105(loftyres_68e5829ea5fe5912e6002105.data);
			set_loftyfilter_68e5829ea5fe5912e6002105__id_iwyddl_ivdhx7(loftyres_68e5829ea5fe5912e6002105.data._id);
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customsizesperproduct_68e5866ca5fe5912e60022b3({
					idofproduct: loftyfilter_68e5829ea5fe5912e6002105__id_iwyddl_ivdhx7,
				});
				setloftyres_68e5866ca5fe5912e60022b3_component_ivdhx7(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, [loftyfilter_68e5829ea5fe5912e6002105__id_iwyddl_ivdhx7, ]);



  
  
  
  

  
  return (
    <div id="id68e6efb78e5aed52dc7f18d3" >

      <div id="iw4j" className="">
      
      <div id="iwv3ah" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggu1zyt.png"
        alt="undefined"
      />
      
      <div className="" id="ivz7uv">
        <>PETRUS GEMS</>
      </div>
      
      </div>
      
      <div id="i023ej" className="">
      
        <a
          target=""
          className=""
          id="ieaxc4"
          href="tel:+50488951552"
        >
          
    <div id="ightd7" className="">
    <>+50488951552</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="ips2" className="">
      
      <div id="i2la9k" className="">
      
      <div id="iowj1k" className="">
      
      <a
        target=""
        className=""
        id="il8xfg"
        href="/"
        type="button"
      >
        
    <div id="ihswfv" className="">
    <>INICIO</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iuicrj"
        href="/productos"
        type="button"
      >
        
    <div id="ih9i7g" className="">
    <>PRODUCTOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link "
        id="ib4wzs"
        href="/certificaciones"
        type="button"
      >
        
    <div id="ie4p6q" className="">
    <>CERTIFICACIONES</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="itj7od"
        href="/contacto"
        type="button"
      >
        
    <div id="i6b0kg" className="">
    <>CONTACTO</>
    </div>
    
      </a>
      
      </div>
      
      <div id="i1ybop" className="">
      
        <a
          target=""
          className=""
          id="ihw7di"
          href="/carritocompras"
        >
          
      <img
        className=""
        id="ixxkxc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgjoujuz.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i3dh" className="">
      
      <div id="ic7saw" className="">
      
        <div id="iwyddl" className="">
        
      <div id="iooy0l" className="">
      
      <div id="iklsqk" className="">
      
        <img
          className=""
          id="iv97av"
          alt=""
          src={loftyendpoint_68e5829ea5fe5912e6002105.loftyUrl}
        />
        
      </div>
      
      <div id="iuty5w" className="">
      
        <div className="" id="ibdre9">
          
          <div className="" id="">
            {loftyendpoint_68e5829ea5fe5912e6002105?.productname}
          </div>
          
        </div>
        
        <div className="" id="ie1kng">
          
            <div className="" id="">
              {parseFloat(loftyendpoint_68e5829ea5fe5912e6002105?.productdesc).toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        
      <div id="i8cry6" className="">
      
      </div>
      
        <div id="ivdhx7" className="">
        
            {
              loftyres_68e5866ca5fe5912e60022b3_component_ivdhx7.map((loftyitem_68e5866ca5fe5912e60022b3_component_ivdhx7) => (
                <div key={loftyitem_68e5866ca5fe5912e60022b3_component_ivdhx7._id} className="" id="i0i4wg">
                  
      <div id="ihzot3" className="">
      
        <div className="" id="iz0jdf">
          
          <div className="" id="">
            {loftyitem_68e5866ca5fe5912e60022b3_component_ivdhx7?.productsize}
          </div>
          
        </div>
        
      </div>
      
        <div className="" id="isgqxk">
          
          <div className="" id="">
            {loftyitem_68e5866ca5fe5912e60022b3_component_ivdhx7?.stockcount}
          </div>
          
        </div>
        
        <div className="" id="inpusx">
          
          <div className="" id="">
            {loftyitem_68e5866ca5fe5912e60022b3_component_ivdhx7?.productrelation}
          </div>
          
        </div>
        
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
}}

      >
      
        <div className="" id="i1xyhg">
          
          <div className="" id="">
            {loftyitem_68e5866ca5fe5912e60022b3_component_ivdhx7?.productsize}
          </div>
          
        </div>
        
      </button>
      
                </div>
              ))
            }
            
        </div>
        
      <div id="iszdvi" className="">
      
      </div>
      
        <div className="" id="i8fwrf">
          
            <div className="" id="">
              {parseFloat(loftyendpoint_68e5829ea5fe5912e6002105?.productprice).toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        
      <div id="i9fhfn" className="">
      
      <button
        type=""
        name=""
        id="ib457e"
        className="cartbutton "
        onClick={async () => {
}}

      >
      
      <div id="ijsmsr" className="">
      <>Agregar al Carrito</>
      </div>
      
      </button>
      
      </div>
      
      </div>
      
      </div>
      
        <div className="" id="iyhlpi">
          
            <div className="" id="">
              {parseFloat(loftyendpoint_68e5829ea5fe5912e6002105?.typeofproduct).toLocaleString('en-US', {minimumFractionDigits: 2})}
            </div>
            
        </div>
        
        <div className="" id="izrnlm">
          
          <div className="" id="">
            {loftyendpoint_68e5829ea5fe5912e6002105?.loftyOriginalName}
          </div>
          
        </div>
        
        <div className="" id="igzlw2">
          
          <div className="" id="">
            {loftyendpoint_68e5829ea5fe5912e6002105?.loftyFileName}
          </div>
          
        </div>
        
        <div className="" id="i1uibk">
          
          <div className="" id="">
            {loftyendpoint_68e5829ea5fe5912e6002105?.loftyUrl}
          </div>
          
        </div>
        
        </div>
        
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        <>Petrus Gems</>
      </div>
      
      <div className="" id="iygu8i">
        <>Elaboración de joyas de forma artesanal por mano de mujeres en nuestras comunidades</>
      </div>
      
      <div id="ix6pbo" className="">
      
        <a
          target=""
          className=""
          id="ibwuje"
          href="https://www.facebook.com/gemspetrus.hn"
        >
          
      <img
        className=""
        id="iy1qpk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiadxwc.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="iqvgxw"
          href="https://www.instagram.com/gemspetrus/"
        >
          
      <img
        className=""
        id="i26xh9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiafdkq.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Enlaces Rápidos</>
      </div>
      
      <div id="iacot" className="">
      
      <a
        target=""
        className=""
        id="i2hsg"
        href="/"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/productos"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Productos</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/certificados"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>Certificados</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ixxmu"
        href="/contacto"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div id="iincid" className="">
      
      <span className="material-icons " id="iwlmju">
        
      <span className="material-icons " id="iz5z0g">
        <>call</>
      </span>
      
      </span>
      
      <div className="" id="i78qcc">
        <>+504 8895-1552</>
      </div>
      
      </div>
      
      <div id="idmnrv" className="">
      
      <span className="material-icons " id="i7tn5m">
        
      <span className="material-icons " id="isg8ci">
        
      <span className="material-icons " id="iuenok">
        <>mail</>
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="il1rnw">
        <>handalcarl13@gmail.com</>
      </div>
      
      </div>
      
      <div id="i2jt24" className="">
      
      <span className="material-icons " id="il9zag">
        
      <span className="material-icons " id="iom84k">
        
      <span className="material-icons " id="i1y0v4">
        
      <span className="material-icons " id="iwl57t">
        <>my_location</>
      </span>
      
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="i1at63">
        <>ubicacion</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pproductinfo);
  